module.exports = {"id":"198641","name":"Kenneth Zohore","rating":"72","photo":"./data/images/photos/0/198641.png","club":{"name":"Cardiff City","logo":"./data/images/clubs/CardiffCity.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KennethZohore0.json
// module id = 2328
// module chunks = 0